import Image from "next/image";
import IconifyIcon from "@/components/wrappers/IconifyIcon";
import { Dropdown, DropdownHeader, DropdownItem, DropdownMenu, DropdownToggle } from "react-bootstrap";

import { userService } from "@/services/user.service";

const ProfileDropdown = (props) => {
	const { userData } = props;

     const handleAccountRedirect = () => {
          return () => {
               window.location.href = "/contul-meu";
          };   
     };

	const handleLogout = () => {
		return () => {
			userService.logout();
		};
	};

	const avatarSrc = userData?.avatar
		? userData.avatar
		: "https://24agency.s3.us-east-1.amazonaws.com/avatar/default.png";

	return (
		<div className='topbar-item nav-user'>
			<Dropdown>
				<DropdownToggle
					className='topbar-link drop-arrow-none px-2'
					data-bs-toggle='dropdown'
					data-bs-offset='0,25'
					type='button'
					aria-haspopup='false'
					aria-expanded='false'>
					<Image
						src={avatarSrc}
						width={32}
						height={32}
						className='rounded-circle me-lg-2 d-flex'
						alt='user-image'
					/>
					<span className='d-lg-flex flex-column gap-1 d-none'>
						<h5 className='my-0'>{userData?.name || "Guest"}</h5>
					</span>
					<IconifyIcon icon='ri:arrow-down-s-line' className='d-none d-lg-block align-middle ms-1' />
				</DropdownToggle>
				<DropdownMenu className='dropdown-menu-end'>
					<DropdownHeader className='noti-title'>
						<h6 className='text-overflow m-0'>Bine ai revenit !</h6>
					</DropdownHeader>
					<DropdownItem onClick={handleAccountRedirect()}>
						<IconifyIcon icon='ri:account-circle-line' className='me-1 fs-16 align-middle' />
						<span className='align-middle'>Contul Meu</span>
					</DropdownItem>
					<div className='dropdown-divider' />
					<DropdownItem onClick={handleLogout()} className='active fw-semibold text-danger'>
						<IconifyIcon icon='ri:logout-box-line' className='me-1 fs-16 align-middle' />
						<span className='align-middle'>Deconectare</span>
					</DropdownItem>
				</DropdownMenu>
			</Dropdown>
		</div>
	);
};
export default ProfileDropdown;
